const headerStyle = {
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "15px",
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
    background: "#7593F2",
    color: "#FFFFFF",
  };
  const cellStyles = {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "13px",
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  };
  
  export const restServiceOverviewTableColumns = [
    {
      key: "check",
      display_name: "",
      cellStyles: { ...cellStyles },
      headerStyles: { ...headerStyle, width: "5%",},
      _config: {
        type: "checkbox",
        displayInColumn: false,
      },
    },
    {
      key: "name",
      display_name: "Operation Name",
      cellStyles: { ...cellStyles },
      headerStyles: headerStyle,
    },
    {
      key: "requestType",
      display_name: "Request Type",
      cellStyles: { ...cellStyles },
      headerStyles: {...headerStyle, width: "15%"},
      _config: {
        type: 'request-type',
        displayInColumn: false,
        classMapping: {
          "DELETE": "operation-delete",
          "PUT": "operation-put",
          "POST": "operation-post",
          "GET": "operation-get",
          "PATCH": "operation-patch"
        }
      }
    },
    {
      key: "url",
      display_name: "Endpoint",
      cellStyles: { ...cellStyles },
      headerStyles: { ...headerStyle},
    },
    {
      key: "edit",
      display_name: "",
      cellStyles: { "font-size": "13px" },
      headerStyles: { ...headerStyle, width: "6%" },
      _config: {
        displayInColumn: false,
        type: "svg",
        value: "../../../../assets/images/table/table-item-edit.svg",
        isClickable: "true",
      },
    },
  ];